/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IShowNoteInfoInput {
    noteDescription?: string;
    resources: {
        noteLabel: string;
        noteErrortext: string;
    };
}

export interface IShowNoteInfo {
    showInfoProps: INodeProps;
    noteDescription: React.ReactNode;
    label: React.ReactNode;
}

const getNoteInfo = ({ noteDescription, resources: { noteLabel, noteErrortext } }: IShowNoteInfoInput): IShowNoteInfo => ({
    showInfoProps: { className: 'ms-checkout-guest-profile__selected-item' },
    noteDescription: (
        <span className='ms-checkout-guest-profile__selected-email'>{noteDescription === '' ? noteErrortext : noteDescription}</span>
    ),
    label: (
        <label id='ms-checkout-guest-profile__label' className='ms-checkout-guest-profile__input-label'>
            {noteLabel}
        </label>
    )
});

export default getNoteInfo;
